<div class="wrap d-flex flex-column justify-content-center align-items-center text-center">
    <div class="logo-wrap">
        <img src="assets/images/logo.png" class="logo" alt="Creditclan Logo" />
    </div>
</div>